import { api, API_URL } from "../config/apiConfig";
import { dataPerPage, handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all users
export const getUsers = async (page, search, startDate = "", endDate = "", sortOrder = "desc", limit,gender) => {
  try {
    const response = await api.get(`${API_URL}/users`, {
      params: { 
        page, 
        search, 
        limit: limit || dataPerPage,
        startDate,
        endDate,
        sortOrder,
        gender
      },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Update an astrologer status
export const updateUserStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(`${API_URL}/users/${id}/status`, updateStatusObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Fetch user wallet history
export const getUserWalletHistory = async ({id,page=1,limit=10 ,startDate="", endDate=""}) => {
  try {
    const response = await api.get(`${API_URL}/users/getWalletHistory/${id}?page=${page}&limit=${limit}&startDate=${startDate ? startDate:""}&endDate=${endDate ? endDate:""}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};